export default Object.freeze({
    AIM: 'AIM',
    ASSET: 'ASSET'
});
